import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    newTitle: { type: String, default: 'New Group' },
    editTitle: { type: String, default: 'Edit Group' },
    emptyMembersMessage: { type: String, default: 'No members in this group' },
    addUserErrorMessage: { type: String, default: 'Failed to add user to group' },
    removeUserErrorMessage: { type: String, default: 'Failed to remove user from group' }
  }

  static targets = [
    'formCard', 'form', 'formTitle',
    'nameField', 'descriptionField', 'idField',
    'userFormCard', 'groupNameDisplay', 'currentMembers',
    'addUserForm', 'userSelect', 'userFormGroupId'
  ]

  connect () {
    // Set up CSRF token for AJAX requests
    this.csrfToken = document.querySelector('meta[name="csrf-token"]').content
  }

  showCreateForm (event) {
    this.formTitleTarget.textContent = this.newTitleValue
    this.formTarget.action = '/groups'
    this.nameFieldTarget.value = ''
    this.descriptionFieldTarget.value = ''
    this.idFieldTarget.value = ''
    this.formCardTarget.classList.remove('d-none')
  }

  showEditForm (event) {
    const groupId = event.currentTarget.dataset.groupId
    const groupName = event.currentTarget.dataset.groupName
    const groupDescription = event.currentTarget.dataset.groupDescription

    this.formTitleTarget.textContent = this.editTitleValue
    this.formTarget.action = `/groups/${groupId}`
    this.nameFieldTarget.value = groupName
    this.descriptionFieldTarget.value = groupDescription
    this.idFieldTarget.value = groupId

    // Add the method field for PATCH
    let methodField = this.formTarget.querySelector('input[name="_method"]')
    if (!methodField) {
      methodField = document.createElement('input')
      methodField.type = 'hidden'
      methodField.name = '_method'
      this.formTarget.appendChild(methodField)
    }
    methodField.value = 'patch'

    this.formCardTarget.classList.remove('d-none')
  }

  hideForm () {
    this.formCardTarget.classList.add('d-none')
  }

  submitForm (event) {
    // Let Turbo handle the form submission
  }

  showUserForm (event) {
    const groupId = event.currentTarget.dataset.groupId
    const groupName = event.currentTarget.dataset.groupName

    // Update the form display
    this.groupNameDisplayTarget.textContent = groupName
    this.userFormGroupIdTarget.value = groupId
    this.addUserFormTarget.action = `/groups/${groupId}/add_user`

    // Fetch and display current members
    this.fetchGroupMembers(groupId)

    this.userFormCardTarget.classList.remove('d-none')
  }

  hideUserForm () {
    this.userFormCardTarget.classList.add('d-none')
  }

  fetchGroupMembers (groupId) {
    // Clear current members list
    this.currentMembersTarget.innerHTML = ''

    fetch(`/groups/${groupId}/members`, {
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': this.csrfToken
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.members.length === 0) {
          const emptyMessage = document.createElement('div')
          emptyMessage.className = 'text-muted'
          emptyMessage.textContent = this.emptyMembersMessageValue
          this.currentMembersTarget.appendChild(emptyMessage)
          return
        }

        data.members.forEach(member => {
          const template = document.getElementById('member-template')
          const clone = template.content.cloneNode(true)

          clone.querySelector('.member-email').textContent = member.email
          const removeBtn = clone.querySelector('.remove-user-btn')
          removeBtn.dataset.userId = member.id
          removeBtn.dataset.groupId = groupId

          this.currentMembersTarget.appendChild(clone)
        })
      })
      .catch(error => console.error('Error fetching group members:', error))
  }

  addUser (event) {
    event.preventDefault()
    const form = event.currentTarget
    const formData = new FormData(form)

    fetch(form.action, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': this.csrfToken,
        Accept: 'application/json'
      },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.userSelectTarget.value = ''
          this.fetchGroupMembers(this.userFormGroupIdTarget.value)

          // Update member count in table
          const row = document.querySelector(`tr[data-group-id="${this.userFormGroupIdTarget.value}"]`)
          if (row) {
            const memberCell = row.cells[2]
            memberCell.textContent = parseInt(memberCell.textContent) + 1
          }
        } else {
          alert(data.error || this.addUserErrorMessageValue)
        }
      })
      .catch(error => console.error('Error adding user to group:', error))
  }

  removeUser (event) {
    const userId = event.currentTarget.dataset.userId
    const groupId = event.currentTarget.dataset.groupId

    fetch(`/groups/${groupId}/remove_user`, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': this.csrfToken,
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ user_id: userId })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.fetchGroupMembers(groupId)

          // Update member count in table
          const row = document.querySelector(`tr[data-group-id="${groupId}"]`)
          if (row) {
            const memberCell = row.cells[2]
            memberCell.textContent = parseInt(memberCell.textContent) - 1
          }
        } else {
          alert(data.error || this.removeUserErrorMessageValue)
        }
      })
      .catch(error => console.error('Error removing user from group:', error))
  }
}
